angular.module('app.controllers').controller('DashboardDefaultCtrl', function ($scope, $timeout, $q, api, notify, UserService, usersOptions) {
    const vm = this;

    vm.userOptions = usersOptions;
    vm.users = [];
    const currentUserId = UserService.getUser().id;
    const belongsToArea = _.find(usersOptions, (o) => o.id == currentUserId);
    if (belongsToArea) {
        vm.users.push(currentUserId);
    }

    const DashboardModel = api('dashboard');
    let timeoutPromise = null;

    $scope.$watch('DashboardDefault.users', () => {
        timeoutPromise && $timeout.cancel(timeoutPromise);
        timeoutPromise = $timeout(() => {
            notify.global(1);

            const p1 = DashboardModel.get('tasks_all', { data: { users: vm.users } }).then((data) => {
                vm.tasks_all = data.data;
                vm.tasks_all_labels = data.labels;
            });

            const p2 = DashboardModel.get('tasks_month', { data: { users: vm.users } }).then((data) => {
                vm.tasks_month = data.data;
                vm.tasks_month_labels = data.labels;
            });

            const p3 = DashboardModel.get('interests_all', { data: { users: vm.users } }).then((data) => {
                vm.interests_all = data.data;
                vm.interests_all_labels = data.labels;
            });

            const p4 = DashboardModel.get('interests_month', { data: { users: vm.users } }).then((data) => {
                vm.interests_month = data.data;
                vm.interests_month_labels = data.labels;
            });

            $q.all([p1, p2, p3, p4]).then(
                () => {
                    notify.global(0);
                },
                () => {
                    notify.global(0);
                }
            );

            timeoutPromise = null;
        }, 1000);
    });
});
